<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <field-input :model="$v.first_name" field-name="First name"/>
      </div>
      <div class="col-md-12 col-lg-6">
        <field-input :model="$v.last_name" field-name="Last name"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6">
        <field-input :model="$v.email" field-name="Email"/>
      </div>
      <div class="col-md-12 col-lg-6 margin-y-1" :class="{ 'has-error' : $v.phone.$error }">
        <label class="control-label col-sm-4"> {{ $phoneFieldName }}:</label>
        <div class="col-sm-8" style="padding-left: 10px; padding-right: 0px">
          <vue-tel-input
            ref="phone"
            name="phone"
            :preferred-countries="['AU', 'GB', 'US']"
            :default-country="$user.region ? $user.region.shortname : null"
            :auto-default-country="$user.region && $user.region.shortname ? true : false"
            :style-classes="$v.phone.$error ? 'red-border form-control' : 'form-control'"
            v-model="$v.phone.$model">
            <template v-slot:arrow-icon="{ open }">{{ open ? "▲" : "▼" }}</template>
          </vue-tel-input>

          <vuelidate-help label="Phone" :field="$v.phone" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import FieldInput from './misc/FieldInput'
import uniqueEmail from '../../validators/uniqueEmail'
import VuelidateHelp from './misc/VuelidateHelp'

export default {
  props: {
    userType: {
      type: String,
      default: ''
    }
  },

  components: {
    FieldInput,
    VuelidateHelp
  },

  mounted () {
    this.$v.phone.$reset()
  },

  data () {
    return {
      first_name: null,
      last_name: null,
      email: null,
      phone: null
    }
  },

  validations () {
    return {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email,
        uniqueEmail
      },
      phone: {
        // required,
        phoneValid: (model) => {
          if (!model) {
            return true
          }
          return !!(this.$refs && this.$refs.phone && this.$refs.phone.phoneObject && this.$refs.phone.phoneObject.valid)
        }
      }
    }
  },

  computed: {
    payload () {
      return {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.$refs.phone && this.$refs.phone.phoneObject ? this.$refs.phone.phoneObject.number : null
      }
    },

    invalid () {
      return this.$v.$invalid
    }
  },

  methods: {
    ...mapActions('user', ['resetUser']),
    ...mapActions('client', ['storeClient']),

    reset () {
      this.first_name = null
      this.last_name = null
      this.email = null
      this.phone = null
      this.$v.$reset()
    },

    validate () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return false
      }
      return true
    }
  }
}
</script>
